import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-news-updates',
    templateUrl: './news-updates.component.html',
    styleUrls: ['./news-updates.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewsUpdatesComponent implements OnInit, OnDestroy {
  cmsResponse: any = '';
  news: any;
  cmsDataSub: Subscription;
  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cmsDataSub = this.cmsData
      .getComponentData('NewsAndUpdateComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
        this.news = this.cmsResponse.content;
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy(): void {
    this.cmsDataSub?.unsubscribe();
  }
}
